import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { PresenceInformationSettingsComponent } from '@business/presence/components/presence-information-settings/presence-information-settings.component';
import { RichPresenceModule } from '@business/rich-presence/rich-presence.module';
import { TranslateModule } from '@ngx-translate/core';
import { PresenceStatesComponent } from './components/presence-states/presence-states.component';

@NgModule({
  declarations: [PresenceInformationSettingsComponent, PresenceStatesComponent],
  imports: [CommonModule, SharedModule, TranslateModule, RichPresenceModule],
})
export class PresenceModule {}
